import { STATUS_SHIPMENT_DELIVERED } from '../constants/orderStatuses'

// Delivered timestamp for the header "Entregado el <fecha>" (multi-package).
// The tracking API does not serialize order.delivered_at, but the order-level
// aggregate writes a shipment_delivered order-history when all packages arrive;
// use the most recent such event. Null-safe: returns null when absent.
export const getOrderDeliveredAt = (order) => {
    const delivered = (order?.order_histories || [])
        .filter((h) => h.new_status === STATUS_SHIPMENT_DELIVERED && h.reference_timestamp)
    if (!delivered.length) return null
    return delivered
        .reduce((latest, h) =>
            new Date(h.reference_timestamp) > new Date(latest.reference_timestamp) ? h : latest
        )
        .reference_timestamp
}
